// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbt_a bib_i bib_j","ColorVariants__color":"bbt_b bib_rp","ColorVariants__more":"bbt_c bib_vv"};